<template>
  <router-view id="page-content-wrapper"></router-view>
</template>

<script>
export default {
  name: "Clinic"
}
</script>

<style scoped>

</style>